export default "/images/728930f3d5d71649927bb52097b35e2c.avif";